import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  SearchConditionOperator,
  SearchJobHistoryConditionsForm,
  SearchQueryConditionsFields,
  SearchQueryConditionsForm,
  SearchQueryConditionTimings,
  SearchQueryWindowType,
} from './search-query-form.models';

export const createSearchQueryConditionForm = (
  field: SearchQueryConditionsFields,
  operator: SearchConditionOperator,
  terms: string[] = []
): SearchQueryConditionsForm =>
  new FormGroup({
    field: new FormControl<SearchQueryConditionsFields>(field),
    terms: new FormControl<string[]>(terms, [Validators.minLength(1)]),
    operator: new FormControl<SearchConditionOperator>(operator),
    time: new FormControl<SearchQueryConditionTimings>('all', [
      Validators.required,
    ]),
    windowType: new FormControl<SearchQueryWindowType>('at-least'),
    windowMonths: new FormControl<number>(0),
  });

export const createSearchJobHistoryConditionForm = (
  operator: SearchConditionOperator
): SearchJobHistoryConditionsForm =>
  new FormGroup({
    roles: new FormControl<string[]>([]),
    affiliations: new FormControl<string[]>([]),
    operator: new FormControl<SearchConditionOperator>(operator, [
      Validators.required,
    ]),
    time: new FormControl<SearchQueryConditionTimings>('all', [
      Validators.required,
    ]),
    windowType: new FormControl<SearchQueryWindowType>('at-least'),
    windowMonths: new FormControl<number>(0),
  });
